import { Injectable } from '@angular/core';
import { HttpServiceBundle } from '@app/core/services/base/http-service-bundle.service';
import { Observable } from 'rxjs';
import { BaseHttpWithBundleService } from '@app/core/services/base/base-service-with-bundle.service';
import { map } from 'rxjs/operators';
import { PaginatedList } from '@app/shared/models/list';
import { BackendUriUnits } from '@app/core/services/base/backend-uri-units';
import {BillingLog, SMPLog} from '@app/shared/models/log';
import { DRResponse } from '@app/shared/models/response';
import { TimePeriod } from '@app/shared/models/time-period';
import { DrI18nService } from '@app/core/services/i18n/i18n.service';


@Injectable({ providedIn: 'root' })
export class BillingLogService extends BaseHttpWithBundleService {

    constructor(httpServiceBundle: HttpServiceBundle, protected drI18nService: DrI18nService) {
        super(httpServiceBundle, true);
        // Setting a new uri because this is not an SMP call
        this.uri += `/${BackendUriUnits.BILLING}/${BackendUriUnits.EVENTS}`;
    }

    public getLogs(from?: Date, to?: Date, type?: string): Observable<any> {
        const params: any = {};

        if (from) {
            params.from = DrI18nService.dateTimeToDateOnlyString(from);
        }

        if (to) {
            params.to = DrI18nService.dateTimeToDateOnlyString(to);
        }

        if (type) {
            params.type = type;
        }

        return this.http.get<DRResponse<BillingLog>>(this.uri, { params: params })
            .pipe(map(result => {
                return result.data;
            }));
    }

}
